import React from 'react';
import Flexbox from 'flexbox-react';
import PropTypes from 'prop-types';
import ProcessField from 'components/core/fields/ProcessField';
import RIEComboBox from 'components/core/editable/RIEComboBox';
import InfoBoxLabel from 'components/core/InfoBoxLabel';
import Constants from 'utils/Constants';

export default class OutputDatastreamsField extends ProcessField {
    static propTypes = Object.assign({
        dods: PropTypes.array
    }, ProcessField.propTypes);

    static defaultProps = Object.assign({
    }, ProcessField.defaultProps);

    getOutputDatastreamClassNames() {
        const process = this.props.process;

        const outputDatastreamClassNames = process.output_datastreams.reduce((accumulator, currentValue) => {
            if (!this.props.dods.includes(currentValue)) {
                accumulator[currentValue] = 'badged-tag orange';
            }
            return accumulator;
        }, {});
        return outputDatastreamClassNames;
    }

    onDatastreamsUpdated = (fieldPath, fieldValue) => {
        // These are combo boxes, so the values will be an array of objects
        // We must map to an array of strings
        const value = fieldValue.map((option) => {
            return option.value;
        });
        this.onFieldUpdated(fieldPath, value);
    };

    render() {
        const process = this.props.process;

        let outputDatastreams = [];
        if (process.output_datastreams) {
            outputDatastreams = Constants.convertArrayToSelectOptions(process.output_datastreams);
        }

        const dodOptions = Constants.convertArrayToSelectOptions(this.props.dods);

        return (
            <Flexbox flexDirection="row" alignItems="flex-start" className={this.props.className}>
                <InfoBoxLabel className="nowrap" label="Output Datastreams" alignTop/>
                <Flexbox flexDirection="column" flexGrow={1}>
                    <RIEComboBox
                        value={outputDatastreams}
                        options={dodOptions}
                        change={this.onDatastreamsUpdated}
                        fieldPath={['output_datastreams']}
                        isDisabled={!this.props.hasWritePermissions}
                        multi
                        clearable
                        creatable
                        tagClassNames={this.getOutputDatastreamClassNames()}
                        tagDefaultClassName="badged-tag grey"
                        processId={this.props.process.name}
                        processErrors={this.props.processErrors}
                        formDisplay={this.props.forceFormDisplay}
                    />

                    {/* Show the legend */}
                    <Flexbox flexDirection="column" margin="10px 0 5px 5px" width="100%">
                        <Flexbox flexDirection="row" alignItems="center" width="100%">
                            <span className="footnote">
                                <i className="fa fa-square grey" aria-hidden="true" />&nbsp;
                                Existing DOD
                            </span>
                        </Flexbox>
                        <Flexbox flexDirection="row" alignItems="center" width="100%">
                            <span className="footnote">
                                <i className="fa fa-square orange" aria-hidden="true" />&nbsp;
                                DOD to be created automatically by ADI
                            </span>
                        </Flexbox>
                    </Flexbox>
                </Flexbox>
            </Flexbox>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/core/fields/OutputDatastreamsField.js